import LOGIN_LEFT_IMG_RCP from "./sign-in-left.jpg";
import RMI_WHITE_LOGO from "./RMI_logo_white.png";
import MOBILE_PREVIEW from "./Mobile_preview.png";
import LOGIN_RIGHT_IMG_RCP from "./sign-in-right.jpg";
import LOGIN_RIGHT_IMG_SYMPHONY from "./sign-in-right-one-sym.jpg";

const LoginRightImg = (import.meta.env.VITE_THEME === "symphony") ? LOGIN_RIGHT_IMG_SYMPHONY : LOGIN_RIGHT_IMG_RCP;
const LoginLeftImg = (import.meta.env.VITE_THEME === "symphony") ? "" : LOGIN_LEFT_IMG_RCP;

export {
    LoginRightImg,
    LoginLeftImg,
    RMI_WHITE_LOGO,
    MOBILE_PREVIEW,
}